export const bytesToGB = (num) => num / (1024 * 1024 * 1024);
export const toPercentage = (part, whole) => (part / whole) * 100;

export default { bytesToGB, toPercentage };
